import React from 'react'
import '../../App.css'
import './Solution.css'
import BackgroundSection from '../BackgroundSection'
import ContainerSection from '../ContainerSection'
import { Title } from '../Title'
import PreFarm from '../../images/prefarm.png'
import Satellites from '../../images/satellites.png'
import InternetOfThings from '../../images/iot.jpg'
import AIBigData from '../../images/aibd.jpg'
import Robotics from '../../images/robotics.jpg'
import Drones from '../../images/drones.jpg'

export const Solution = () => {
  return (
    <>
      <BackgroundSection
        className='background'
        backgroundStyle='background--fifth'
      >
        Solution
      </BackgroundSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          Monitoring Agricultural Production
        </Title>
        <div className='sol-container'>
          <div className='sol-pic-container'>
            <img className='prefarm' src={PreFarm} alt='Precision Farming' />
          </div>
          <div className='sol-text-container'>
            <p className='sol-text'>
              Monitoring crop growth and producing early forecasts of planted
              crops are of immense importance for planners and policymakers at
              the national level in areas related to food security. Reliable,
              timely and credible information enables planners and decision
              makers to handle deficits or surpluses of food crops in a given
              year in an optimal manner. Timely and reliable national
              agricultural statistics can be obtained through the establishment
              of an adequate, periodic national agricultural survey based on
              probability-sampling methods, image classification and adherance
              to well-defined and reproducible techniques.
            </p>
            <p className='sol-text'>
              Spectral analysis of high resolution satellite images enables the
              performance of real-time monitoring of crop vegetation indices for
              different fields and crops as well as the identification and
              tracking of positive and negative dynamics of crop development.
              Such dynamics, revealed by differences in vegetation indices,
              provide signals about disproportions in single crio development.
              In addition to crop health and change detection, spaced-based
              platforms provide inputs for environmental analysis, irrigated
              landscape mapping, yield determination and soil analysis. All of
              these techniques, when integrated in decision-making models, may
              inform of the necessity of specific agricultural interventions in
              particular field zones.
            </p>
            <p className='sol-text'>
              The use of a number of ancillary data, including the integral use
              of remotely sensed data, is a key component in effective
              monitoring of agricultural production. Earth observation data is
              now used regularly to monitor the crop season, and satellite
              imagery coverage integrated with field surveys allows the
              quantification of areas planted and to be harvested during crop
              seasons. United Nations entities continue to provide support to
              Member States in enhancing their national capacities to make
              improved crop forecasts and production estimates.
            </p>
          </div>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        {' '}
        <Title
          className='title'
          titleStyle='title--title2'
          titleSize='title--medium'
        >
          Satellites
        </Title>
        <div className='space-tech-section'>
          <div className='space-tech1-section'>
            <div className='space-tech-container'>
              <img className='satellites' src={Satellites} alt='Satellites' />
            </div>
            <div className='space-text-container'>
              <ul className='space-list'>
                <h3 className='space-list-title'>Related Technologies</h3>
                <li className='space-list-item'>IoT</li>
                <li className='space-list-item'>Big Data</li>
                <li className='space-list-item'>Artificial Intelligence</li>
                <li className='space-list-item'>Robotics</li>
                <li className='space-list-item'>Drones</li>
              </ul>
            </div>
          </div>
          <div className='space-text-container'>
            <p className='space-text'>
              <strong className='space-bold-text'>Data Collection:</strong>{' '}
              Satellite technology enables farmers to gather soil and crop
              condition information about specific fields, including nutrient
              levels and information about previous crops. Such information,
              when processed and presented, can assist farmers in making
              decisions about variations in fertiliser, chemical, and water
              applications. Satellites can also assist in providing information
              on potential yields, soil types, crop or soil colour index maps,
              soil types and electromagnetic soil mapping.
            </p>
            <br />
            <p className='space-text'>
              <strong className='space-bold-text'>
                Environmental Protection:
              </strong>{' '}
              Precision agriculture and satellites hold potential to reduce the
              environmental risks and footprints of farming by limiting
              fertiliser and chemical runoff through enabling decisions about
              more efficient applications. For example, VRT for nutrient
              application directly contributes to lowered emissions, with
              studies showing the technology can reduce fertiliser use 10-30%,
              while maintaining the same productivity.
            </p>
            <br />
            <p className='space-text'>
              <strong className='space-bold-text'>Connectivity:</strong>{' '}
              Increasingly, satellites will enable connectivity within remote
              and regional areas.
            </p>
          </div>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        {' '}
        <Title
          className='title'
          titleStyle='title--title2'
          titleSize='title--medium'
        >
          Internet of Things
        </Title>
        <div className='space-tech-section'>
          <div className='space-tech1-section'>
            <div className='space-tech-container'>
              <img
                className='iot'
                src={InternetOfThings}
                alt='Internet of Things'
              />
            </div>
            <div className='space-text-container'>
              <ul className='space-list'>
                <h3 className='space-list-title'>Related Technologies</h3>
                <li className='space-list-item'>
                  Remote Sensing, including Drones and Satellites
                </li>
                <li className='space-list-item'>Big Data</li>
                <li className='space-list-item'>Artificial Intelligence</li>
                <li className='space-list-item'>Automation/Robotics</li>
              </ul>
            </div>
          </div>
          <div className='space-text-container'>
            <p className='space-text'>
              <strong className='space-bold-text'>
                Precision Agriculture:
              </strong>{' '}
              IoT devices collect data that can help improve grower decision
              making, including the ability to cut costs, improve yields,
              monitor crops, and generally increase situational awareness across
              the farming operation. Field sensors connected to the IoT can
              record information regarding soil moisture and nutrient levels,
              control water usage for efficient irrigation systems, determine
              custom fertiliser blends based on soil profiles, and determine the
              optimal time to plant and harvest. In greenhouses, IoT sensors can
              eliminate the need for manual monitoring as the completely
              controlled environment can be tweaked to change temperature,
              humidity, light levels and carry out automatic irrigation.
            </p>
            <br />
            <p className='space-text'>
              <strong className='space-bold-text'>
                Improving Suppy Chains:
              </strong>{' '}
              The IoT is being utilised to monitor commodities along the supply
              chain to ensure quality, safety, and efficiency, as well as enable
              traceability for consumers and regulators. By providing
              visibility, IoT sensors can help to advoid spoilage of perishable
              items by monitoring and sending safety alerts when the condition
              of goods deviate from safe levels. By monitoring the goods during
              transportation, food manufacturers can identify possible
              contaminated items which, during times of food recalls, can
              accelerate the investigation process and give quality assurance to
              consumers.
            </p>
          </div>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        {' '}
        <Title
          className='title'
          titleStyle='title--title2'
          titleSize='title--medium'
        >
          Artificial Intelligence and Big Data
        </Title>
        <div className='space-tech-section'>
          <div className='space-tech1-section'>
            <div className='space-tech-container'>
              <img className='aibd' src={AIBigData} alt='AI and Big Data' />
            </div>
            <div className='space-text-container'>
              <ul className='space-list'>
                <h3 className='space-list-title'>Related Technologies</h3>
                <li className='space-list-item'>Satellites</li>
                <li className='space-list-item'>IoT</li>
                <li className='space-list-item'>Sensors</li>
                <li className='space-list-item'>Robotics</li>
                <li className='space-list-item'>Gene Editing</li>
                <li className='space-list-item'>Synthetic Biology</li>
              </ul>
            </div>
          </div>
          <div className='space-text-container'>
            <p className='space-text'>
              The synthesis of Big Data and use of AI can help farmers gain
              acess to complex information that can inform critical on-farm
              decisions. Big Data is required to enable AI and both technologies
              are integral to each other's success. The applications in
              agriculture offer huge potential for the industry. Although the
              technology can be applied in a wide range of settings, here are
              examples of jusr a few:
            </p>
            <br />
            <ul className='space-text-list'>
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>
                    Development of New Plant Seeds:
                  </strong>{' '}
                  Huge developments in biological information collection and
                  analysis have accelerated plant genomics. Research in labotary
                  settings is producing data that can be analysed to develop new
                  hybrid seeds that perform across different ranges of
                  environments.
                </p>
              </li>
              <br />
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>
                    Precision Farming:
                  </strong>{' '}
                  New technologies and software that track yields, control
                  equipment, monitor field conditions and manage inputs at
                  precise levels across fields are sustantially increasing
                  productivity and profitability. Software with machine learning
                  allow for smarter and more customized interactions which are
                  creating opportunities for better decision-making on the farm.
                </p>
              </li>
              <br />
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>
                    Reduced operating costs:
                  </strong>{' '}
                  The opportunity that Big Data and AI offer to agriculture is
                  the potential for better cost allocation and reduction in
                  operating costs via targeted allocation of inputs such as
                  fertiliser and chemical application. The consumer benefit of
                  this is the opportunity for potential benefits around quality
                  and volume of production that could see price benefits longer
                  term as these costs savings are realised.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        {' '}
        <Title
          className='title'
          titleStyle='title--title2'
          titleSize='title--medium'
        >
          Robotics
        </Title>
        <div className='space-tech-section'>
          <div className='space-tech1-section'>
            <div className='space-tech-container'>
              <img className='robotics' src={Robotics} alt='Robotics' />
            </div>
            <div className='space-text-container'>
              <ul className='space-list'>
                <h3 className='space-list-title'>Related Technologies</h3>
                <li className='space-list-item'>Drones</li>
                <li className='space-list-item'>AI</li>
                <li className='space-list-item'>Satellites</li>
                <li className='space-list-item'>IoT</li>
                <li className='space-list-item'>Sensors</li>
              </ul>
            </div>
          </div>
          <div className='space-text-container'>
            <p className='space-text'>
              <strong className='space-bold-text'>Crop Management:</strong> The
              use of robotics for tasks such as mowing, pruning, seeding and
              thinning crops will be of particular benefit to horticulture. For
              specialty crops in horticulture such as lettuce, broccoli,
              tomatoes and onion, robotic weeding is beginning to replace the
              need for hand-weeding which is slow and becoming increasingly more
              expensive. Developments in robotic weeding have the potential to
              cut the cost of weed control significantly.
            </p>
            <br />
            <p className='space-text'>
              <strong className='space-bold-text'>
                Labour reduction and production improvements
              </strong>
            </p>
            <br />
            <ul className='robotics-list'>
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>Dairies:</strong> Robotics
                  used in dairies provide fully automated milking systems and
                  reduce the need for labour in the dairy, such that it can be
                  deployed elsewhere on farm. Installation of robotic dairies
                  can contribute to an increase in milk production while the
                  price of automated systems is moving towards being comparable
                  to traditional rotary-style dairies.
                </p>
              </li>
              <br />
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>Cropping:</strong> High
                  speed planting technology that is evolving rapidly has the
                  opportunity to combine with autonomous tractors and sensors
                  along with management software to help lift crop yields by 70%
                  by 2050. As noted above, the developments in robotic weeding
                  holds significant opportunity to reduce labour costs.
                </p>
              </li>
              <br />
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>
                    Autonomous tractors:
                  </strong>{' '}
                  Hold huge potential for diversification of production. For
                  example, farmers that cannot expand into other crops or
                  different production systems (e.g.,organic) because of a lack
                  of equipment currently, may be able to do so if/when current
                  equipment business models are disrupted by smaller, autonomous
                  (swarm, electric, etc.) equipment solutions.
                </p>
              </li>
              <br />
            </ul>
            <ul className='space-text-list'>
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>Harvesting:</strong>{' '}
                  Currently being developed at an experimental level, the use of
                  robots could be applied during the harvesting phase for crops,
                  reducing labour costs for farmers and increasing efficiency
                  while saving time. Although robotics for harvesting is still
                  in a development stage, there is evidence that the technology
                  is being utilised by greenhouse and vegetable growers.
                </p>
              </li>
              <br />
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>Manufacturing:</strong>{' '}
                  Utilising robotics during the food processing and packaging
                  phases already improves the production line to create safer
                  and more efficient conditions. Automation has traditionally
                  benefited larger companies with products of high volume, long
                  life or a single product. However with advancements in robotic
                  technology, faster and more agile machines are completing more
                  complicated tasks for a larger variety of products and at a
                  reduced price which for smaller manufacturers, could come as a
                  huge benefit.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        {' '}
        <Title
          className='title'
          titleStyle='title--title2'
          titleSize='title--medium'
        >
          Drones
        </Title>
        <div className='space-tech-section'>
          <div className='space-tech1-section'>
            <div className='space-tech-container'>
              <img className='drones' src={Drones} alt='Drones' />
            </div>
            <div className='space-text-container'>
              <ul className='space-list'>
                <h3 className='space-list-title'>Related Technologies</h3>
                <li className='space-list-item'>
                  Remote Sensing, including Satellites
                </li>
                <li className='space-list-item'>
                  Big Data, especially around multi - spectral imagery
                </li>
                <li className='space-list-item'>
                  AI/Automation for long range flights
                </li>
              </ul>
            </div>
          </div>
          <div className='space-text-container'>
            <p className='space-text'>
              Through instant data gathering and processing, drones have the
              potential to help agriculture in the following ways:
            </p>
            <br />
            <ul className='space-text-list'>
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>
                    Soil and Field Analyses:
                  </strong>{' '}
                  Drones have the capability to produce precise maps for soil
                  analysis in pre-planting, and further analysis for irrigation
                  application, fertiliser and chemical requirements. Using
                  normalized difference vegetation index (NDVI), a mapping
                  method that identifies whether an area contains live green
                  vegetation, data from drones can be applied to gridded
                  management maps, where information can be used within variable
                  rate systems for sowing, spraying and other management
                  operations.
                </p>
              </li>
              <br />
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>Crop Spraying:</strong>{' '}
                  With automated distance-measuring equipment, drones can scan
                  the ground and spray the correct amount of chemicals with
                  increased efficiency and descreased environmental impacts.
                  This targeted spraying of chemicals is a key beneficial
                  feature of drones, as it reduces input costs and provides
                  positive environmental outcomes such as a descrease in
                  chemical and aritificial fertiliser use.
                </p>
              </li>
              <br />
              <li>
                <p className='space-text'>
                  <strong className='space-bold-text'>
                    Health Assessment:
                  </strong>{' '}
                  Drones can be used to provide high resolution imagery to show
                  detailed crop development and reveal crop health and spot
                  bacterial or fungal infection on trees. By scanning a crop
                  using both visible and near-infrared light, drone-carried
                  devices can identify which plants reflect different amounts of
                  green lgiht and NIR light. This information can produce
                  multispectral images that track changes in plants and indicate
                  their health. Farmers can therefore monitor crops for disease
                  and in the case of damaging weather events, document losses
                  more efficiently for insurance claims.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </ContainerSection>
    </>
  )
}
